module.exports = __webpack_public_path__ + "static/media/all-together.5fc6c5a7.svg";